module.exports = __webpack_public_path__ + "img/145ne.5304b4cc.svg";